import configService from "@app/config/ConfigService";

const complementFileUrl = (url?: null | string): string | undefined =>
  url ? (url.startsWith("http") ? "" : configService.getBaseApiUrl()) + url : undefined;

export default complementFileUrl;
